define(function () {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	return IpsModelCollection.extend({
		urlRoot:'/delegate/civics-api/api/portal/users/availablefactors',

		parse:function(response){
			let data = response.data;
			data.forEach(factor => {
				let prettyMethod = i18n.t('CIVICS.COMMON.'+factor.notificationMethod.toUpperCase());
				if (prettyMethod == 'CIVICS.COMMON.'+factor.notificationMethod.toUpperCase()){
					prettyMethod = factor.notificationMethod;
				}
				factor.prettyMethod = prettyMethod;
			});
			return data;
		}
	});
});